var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9615,
    cy: 17.0384,
    r: 16.4615,
    fill: "#D9D9D9",
    stroke: "#4D515A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9701 9.43602C27.6236 10.067 27.6236 11.0867 26.9701 11.7178L13.5854 24.6408C12.9319 25.2718 11.8758 25.2718 11.2222 24.6408L4.52845 18.1793C3.87512 17.5483 3.87512 16.5286 4.52845 15.8976C5.1819 15.2665 6.24116 15.2665 6.89471 15.8976L12.3568 21.2132L24.6068 9.43602C25.2604 8.804 26.3165 8.804 26.9701 9.43602Z",
    fill: "#07A403"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4231,
    height: 25.8462,
    fill: "white",
    transform: "translate(4.03845 4.11536)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c262c067e01a19a697343f0f9a9d5b56.svg";
export { ForwardRef as ReactComponent };